import Commands from './commands';

class Equal extends Commands {
    constructor(registry) {
        super("equal", registry);
    }

    async execute(node, emitter, options) {
        const param1 = await emitter(node.params[0], options);
        const param2 = await emitter(node.params[1], options);
        return param1 === param2 || param1.toString() === param2.toString();
    }
}

export default Equal;
